import Box from '@/components/UI/box/Box';
import { FC, Fragment } from 'react';
import Styles from './HouseServices.module.scss';
import Divider from '@/components/UI/divider/Divider';
import Typography from '@/components/UI/typography/Typography';
import Image from 'next/image';
import HouseServicesCardItem from './HouseServicesCardItem/HouseServicesCardItem';
import ShowMorePopUp from '@/components/houses/_reusable/houseInfo/ShowMorePopUp/ShowMorePopUp';
import Badges from '@/components/UI/badges/Badges';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
type Props = {
  props: ProductItemTypes;
};
const meals = ['breakfast', 'lunch', 'dinner'];
const generateServices = items => {
  const res: any = [];
  if (!items) return res;
  for (const item of items) {
    if (item.feature_name === 'experience') {
      for (const exp of item.meta_data) {
        res.push({
          ...exp,
          icon_url: item?.icon_url
        });
      }
    } else {
      res.push(item);
    }
  }
  return res;
};
const HouseServices: FC<Props> = ({
  props
}) => {
  const services = generateServices(props?.features?.filled_categories?.['accommodation_services']);
  return <>
      {!!services.length && <Box className={Styles['house-services']} component={'section'}>
          <Box className={Styles['container']}>
            <Typography variant="bodyL_Bold" color="neutral_800" component="h2">
              خدمات اقامتگاه
            </Typography>
            <Box className={Styles['flat-content']}>
              <Box className={Styles['flat-items']}>
                {[...services].splice(0, 4).map((item, index) => <Fragment key={`FLAT_SERVICES_${index}`}>
                    <Box className={Styles['flat-item']}>
                      <Box className={Styles['flat']}>
                        <Box className={Styles['title']}>
                          <Image src={item?.icon_url} alt={item?.feature_label || item?.title} width={24} height={24} />
                          <Typography variant="bodyM" color="neutral_800">
                            {item?.feature_label || item?.title}
                          </Typography>
                        </Box>
                        <Box className={Styles['badge']}>
                          {meals.includes(item.feature_name) && <Badges label={item.meta_data?.is_free ? 'رایگان' : 'هزینه دارد'} type="default" />}
                        </Box>
                      </Box>
                    </Box>

                    {index % 2 === 0 && <Divider orientation="vertical" />}
                  </Fragment>)}
              </Box>
            </Box>
          </Box>
          {(services?.length > 4 || !!services.find(item => item.description)) && <ShowMorePopUp title="services">
              {services.map((item, index) => <HouseServicesCardItem item={item} key={`SERVICES_${index}`} />)}
            </ShowMorePopUp>}
          <Divider orientation="horizontal" />
        </Box>}
    </>;
};
export default HouseServices;